@if (loading) {
   <app-spinner></app-spinner>
}

<div [hidden]="!error">
   <div class="row">
      <div class="col-sm-4 nopadding">
         <h1>{{ pageHeading }}</h1>
         <span [innerHTML]="errorText"></span>
      </div>
   </div>
</div>

<div class="row">
   @if (!loading) {
      <div class="col-sm-4 nopadding">
         <h1>{{ pageHeading }}</h1>
      </div>
   }
   <!-- <h3>Role Nuve {{ roleNuvu }} RolePrs {{ rolePrs }} stage {{ repairsData.repairStage }}</h3> -->
   <div class="col-sm-8 text-right nopadding">
      <span>
         <a href="/help-and-advice/forms/general-enquiry/"
            style="margin-top: 20px; margin-bottom: 10px; text-wrap: wrap"
            class="table__btn btn btn-secondary"
            >Contact us about a problem booking a repair</a
         >
      </span>

      @if (roleNuvu === 'True') {
         <span>
            <a
               href="/repairs/report-a-repair-nuvu/"
               style="margin-top: 20px; margin-bottom: 10px; text-wrap: wrap"
               class="table__btn btn btn-secondary"
               >Book a repair</a
            >
         </span>
      }
      @if (rolePrs === 'True') {
         <span>
            <a
               href="/repairs/report-a-repair-prs/"
               style="margin-top: 20px; margin-bottom: 10px; text-wrap: wrap"
               class="table__btn btn btn-secondary"
               >Book a repair</a
            >
         </span>
      }
   </div>
</div>

@if (repairsData.appointmentsFound === false && repairsData.repairStage === 'New') {
   <app-repair-summary [repairSummary]="repairsData.repair" [roleNuvu]="roleNuvu" [rolePrs]="rolePrs"> </app-repair-summary>
}

@if (repairsData.futureAppointments !== null) {
   <div class="appointments" [hidden]="!(repairsData.futureAppointments.length > 0)">
      @for (month of repairsData.futureAppointments; track month.name) {
         <table class="appointments__table table table-striped">
            <caption class="appointments__caption">
               {{
                  month.name
               }}
            </caption>
            <thead class="sr-only">
               <tr>
                  <th>Date</th>
                  <th>Description</th>
               </tr>
            </thead>
            <tbody>
               @for (appointment of month.appointments; track appointment.repairJobId) {
                @if (appointment.repairStatus !== 'Canceled') {
                  <tr class="appointment">
                     <td class="appointment__dates appointment__description">
                        @if (appointment.appointmentDescription !== null ? appointment.appointmentDescription!.indexOf('TBC') > -1 : '') {
                           <div style="color: #63656a">
                              <p class="appointment__day">TBC</p>
                           </div>
                        }
                        @if (appointment.appointmentDescription !== null ? appointment.appointmentDescription!.indexOf('TBC') <= -1 : '') {
                           <div style="color: #63656a">
                              <p class="appointment__day" [ngStyle]="{ color: appointment.repairStatus === 'Canceled' ? '#63656A' : null }">
                                 {{ appointment.startTime | date: 'EEE' }}
                              </p>
                              <p class="appointment__month" [ngStyle]="{ color: appointment.repairStatus === 'Canceled' ? '#63656A' : null }">
                                 {{ ordinalDate(appointment.startTime) }} {{ appointment.startTime | date: 'LLLL' }}
                              </p>
                              <p class="appointment__time" [ngStyle]="{ color: appointment.repairStatus === 'Canceled' ? '#63656A' : null }">
                                 {{ appointment.startTime | date: 'HH' }}:{{ appointment.startTime | date: 'mm' }}
                              </p>
                           </div>
                        }
                     </td>
                     <td>
                        @for (repairDescription of appointment.repairDescription; track $index) {
                           <h3 class="appointment__heading">
                              {{ appointment.repairDescription }}
                           </h3>
                        }

                        <!-- Removed in ticket #2039 -->
                        <!--<p class="appointment__description" *ngIf="appointment.repairStatus !== 'Canceled'">{{appointment.contractorName}} will be attending</p>-->

                        @if (appointment.repairStatus === 'Canceled') {
                           <p class="appointment__description">Cancelled</p>
                        }
                        <p class="appointment__description">Job Number: {{ appointment.jobNumber }}</p>
                        <p class="table__btns">
                           @if (appointment.reschedule === true && appointment.pickerReschedule === true) {
                              @if (repairBookingAvailable === 'true') {
                                 <a
                                    [href]="'/repairs/book-a-repair/?assetId=' + appointment.assetId + '&data=' + appointment.rescheduleUrl"
                                    type="button"
                                    class="table__btn btn btn-primary"
                                    >Rearrange</a
                                 >
                              } @else {
                                 <button type="button" class="table__btn btn btn-primary" disabled>Rearrange Unavailable</button>
                              }
                           }
                           @if (appointment.reschedule === true && appointment.pickerReschedule === false) {
                              <a [href]="appointment.rescheduleUrl" type="button" class="table__btn btn btn-primary">Rearrange</a>
                           }
                           @if (appointment.cancel === true) {
                              <a
                                 [href]="
                                    '/repairs/repair-cancel?slotKey=' +
                                    appointment.slotKey +
                                    '&repairJobId=' +
                                    appointment.repairJobId +
                                    '&repairId=' +
                                    appointment.repairId
                                 "
                                 type="button"
                                 class="table__btn btn btn-secondary"
                                 >Cancel</a
                              >
                           }
                           @if (appointment.repairStatus === 'Canceled') {
                              <a
                                 [href]="
                                    '/repairs/repair-feedback?slotKey=' +
                                    appointment.slotKey +
                                    '&repairJobId=' +
                                    appointment.repairJobId +
                                    '&repairId=' +
                                    appointment.repairId
                                 "
                                 type="button"
                                 class="table__btn btn btn-secondary"
                                 >Feedback</a
                              >
                           }
                        </p>
                     </td>
                  </tr>
                }
               }
            </tbody>
         </table>
      }
   </div>
}
@if (repairsData.previousAppointments !== null) {
   @if (repairsData.previousAppointments.length > 0) {
      <div class="page-header">
         <h2>Previous Repairs</h2>
      </div>
   }
   @if (repairsData.previousAppointments.length > 0) {
      <div class="appointments">
         @for (appointment of repairsData.previousAppointments; track appointment.repairJobId) {
          @if (appointment.appointmentStatus !== 'Canceled') {
            <table class="appointments__table table table-striped">
               <caption class="appointments__caption sr-only">
                  {{
                     appointment.startTime | date: 'LLLL'
                  }}
                  {{
                     appointment.startTime | date: 'yyyy'
                  }}
               </caption>
               <thead class="sr-only">
                  <tr>
                     <th>Date</th>
                     <th>Description</th>
                  </tr>
               </thead>
               <tbody>
                  <tr class="appointment appointment--previous">
                     <td class="appointment__dates">
                        <p class="appointment__day">{{ appointment.startTime | date: 'dd' }}</p>
                        <p class="appointment__month">{{ appointment.startTime | date: 'LLLL' }}</p>
                        <p class="appointment__month">{{ appointment.startTime | date: 'yyyy' }}</p>
                     </td>
                     <td>
                        @for (repairDescription of appointment.repairDescription; track $index) {
                           <h3 class="appointment__heading">
                              {{ repairDescription }}
                           </h3>
                        }

                        <!-- Removed in ticket #2039 -->
                        <!--<p class="appointment__description">Your repair was completed by {{appointment.contractorName}}</p>-->

                        <p class="appointment__description">Job Number: {{ appointment.jobNumber }}</p>
                        <p class="table__btns table__btns--float">
                           @if (appointment.feedback === true) {
                              <a
                                 [href]="'/repairs/repair-feedback?repairJobId=' + appointment.repairJobId + '&repairId=' + appointment.repairId"
                                 type="button"
                                 class="table__btn btn btn-primary"
                                 >Feedback</a
                              >
                           }
                           &nbsp;
                           @if (appointment.recall === true) {
                              <a
                                 [href]="'/repairs/repair-recall?repairJobId=' + appointment.repairJobId + '&repairId=' + appointment.repairId"
                                 type="button"
                                 class="table__btn btn btn-secondary"
                                 >Still not fixed?</a
                              >
                           }
                        </p>
                     </td>
                  </tr>
               </tbody>
            </table>
          }
         }
      </div>
   }
}
